const  ttrs = {
  сontentMenegment: {
     marginTop: '0px',
     snackbarAbsoute: true,
     items: {
       selector: {active:true},
       copy: {active:true},
       export: {active:true},
       update: {active:false},
       delete: {active:false},
       autoExport: {active:false},
       toDone: {active:true},
       toTail: {active:true},
       toMinus_traff: {active:true},
       toBots: {active:true},
     },
     contentInfo: {
       type: 'pages',
     },
     autoExport: {
       isActive: false,
       tasksList:[],
    },
    init:{}
  },
  сontentMenegment1: {
     marginTop: '0px',
     snackbarAbsoute: true,
     items: {
       selector: {active:true},
       copy: {active:true},
       export: {active:true},
       update: {active:false},
       delete: {active:false},
       autoExport: {active:false},
       toDone: {active:true},
       toUnDone: {active:true},
       toMinus_traff: {active:true},
       toBots: {active:true},
     },
     contentInfo: {
       type: 'pages',
     },
     autoExport: {
       isActive: false,
       tasksList:[],
    },
    init:{}
  },
  сontentMenegmentD: {
     marginTop: '0px',
     snackbarAbsoute: true,
     items: {
       selector: {active:true},
       copy: {active:true},
       export: {active:true},
       update: {active:false},
       delete: {active:false},
       autoExport: {active:false},
       toUnDone: {active:true},
       toTail: {active:true},
       toMinus_traff: {active:true},
       toBots: {active:true},
     },
     contentInfo: {
       type: 'pages',
     },
     autoExport: {
       isActive: false,
       tasksList:[],
    },
    init:{}
  },
  сontentMenegmentMinus_traff: {
     marginTop: '0px',
     snackbarAbsoute: true,
     items: {
       selector: {active:true},
       copy: {active:true},
       export: {active:true},
       update: {active:false},
       delete: {active:false},
       autoExport: {active:false},
       toUnDone: {active:true},
       toTail: {active:true},
       toBots: {active:true},
       toDone: {active:true},
     },
     contentInfo: {
       type: 'pages',
     },
     autoExport: {
       isActive: false,
       tasksList:[],
    },
    init:{}
  },
  сontentMenegmentBots: {
     marginTop: '0px',
     snackbarAbsoute: true,
     items: {
       selector: {active:true},
       copy: {active:true},
       export: {active:true},
       update: {active:false},
       delete: {active:false},
       autoExport: {active:false},
       toUnDone: {active:true},
       toTail: {active:true},
       toDone: {active:true},
       toMinus_traff: {active:true},
     },
     contentInfo: {
       type: 'pages',
     },
     autoExport: {
       isActive: false,
       tasksList:[],
    },
    init:{}
  },
  foundData:{
    selector: false,
    foundIds: [],
    displayIds: [],
    selectedIds: [],
    offset: 0,
    selectAll: false
  }



}





export  default {
ttr(){
  return  ttrs;
}
}
